var options = {
  root: null,
  rootMargin: '50%',
  threshold: 0
};

var requestedTab;

document.addEventListener('DOMContentLoaded', function () {
  var reviewObserver;
  var reviews = document.querySelectorAll('.yotpo-main-widget,[data-review-frame]');
  requestedTab = window.location.hash;

  // eslint-disable-next-line
  reviewObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        loadReviews();
        reviewObserver.unobserve(entry.target);
      }
    });
  });

  reviews.forEach(function (review) {
    reviewObserver.observe(review, options);
  });
});

function loadReviews() {
  const css = document.createElement('link');
  const script = document.createElement('script');

  css.rel = 'stylesheet';
  css.type = 'text/css';
  css.media = 'all';
  css.href = "//simbasleep.com/cdn/shop/t/4965/assets/legacy-yotpo.scss?v=120846879365892418901791805705";

  script.type = 'text/javascript';
  script.src = 'https://staticw2.yotpo.com/' + Simba.yotpoKey + '/widget.js';

  document.body.appendChild(css);
  document.body.appendChild(script);

  if (requestedTab) {
    changeTab(requestedTab.split('_')[1]);
    requestedTab = null;
  }

  initTabs();
  clearLoader();
}

function clearLoader() {
  const loaders = document.querySelectorAll('[data-review-frame] [data-loader], .yotpo-main-widget [data-loader]');
  const activeTab = document.querySelector('[data-review-frame] .active');

  if (loaders.length > 0) {
    loaders.forEach((loader) => loader.remove());
  }

  if (activeTab !== null) {
    activeTab.classList.remove('hidden');
  }
}

function initTabs() {
  const tabs = document.querySelectorAll('[data-tabs] [data-type], [data-mobile-menu] [data-type]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      changeTab(tab.dataset.type);
    });
  });
}

function changeTab(type) {
  const tabs = document.querySelectorAll('[data-tabs] [data-type]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (Simba.Viewport().width < 1024) {
    mobileMenu?.classList?.toggle('active');
  }

  tabs.forEach((tab) => {
    const img = tab.querySelector('img');
    tab.classList.remove('active');
    img?.classList?.remove('active');
    document.querySelector('#content-' + tab.dataset.type)?.classList?.replace('active', 'hidden');

    if (tab.dataset.type === type) {
      tab.classList.add('active');
      img?.classList?.add('active');

      document.querySelector('#content-' + type)?.classList?.replace('hidden', 'active');
    }
  });
}
